var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsulting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 63,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.38 30.72h14v-16h-40v30h26zM5.47 56.13h51.82v6H5.47z",
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.47 4.31h61.82v51.82H.47zm56.82 57.82H5.47M30.68.31v7m-20-7v7m40-7v7m-39.3 7.41h40m-40 10h40m-40 10h21m-21 10h21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.38 30.72h18v18h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61 36.77l-5.64 5.89-2.82-2.94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting2);
export default __webpack_public_path__ + "static/media/Consulting2.9391625ef3998bc0d64fc92d2f5960ef.svg";
export { ForwardRef as ReactComponent };